<template>
    <div class="page-modal">
        <widgetModal :title="event ? 'Edit Event' : 'Add New Event'"
            :subtitle="event ? 'Edit event details' : 'Fill in details to add a new event'"
            :btnlefttext="event ? 'Update Event' : 'Add Event'" btncentertext="Cancel" :leftloading="loading"
            :centerloading="false" :footerhidden="false" footer_padding="10px 18px 30px 30px" :hiderightbtn="true"
            header_padding="30px 0px 0px 31px" body_padding="0px 30px" width="400px" @onLeftClick="onConfirm"
            @onCenterClick="onCancel">
            <div class="widget-modal-body-noscoll">
                <div class="row">
                    <widgetInputWrapper title="Event Title">
                        <widgetInput v-model="eventForm.title" type="text" placeholder="Enter event title">
                        </widgetInput>
                    </widgetInputWrapper>
                </div>
                <div class="row" v-if="type === 'google'">
                    <widgetInputWrapper title="Meet Link">
                        <widgetCheckbox title="Generate Google Meet Link" v-model="eventForm.canGenerateGoogleMeetLink">
                        </widgetCheckbox>
                    </widgetInputWrapper>
                </div>
                <div class="row">
                    <widgetInputWrapper title="Start Date & Time">
                        <div class="row">
                            <datetime class="input-date" v-model="eventForm.start" type="datetime"
                                format="yyyy-MM-dd HH:mm" :min-datetime="moment().toISOString()" style="width: 100%">
                                <span class="date-icon" slot="after"
                                    style="padding: 0px; margin-top: 3px; padding-right: 10px">
                                    <img src="@/assets/admin-icon/calendar.svg" />
                                </span>
                            </datetime>
                        </div>
                    </widgetInputWrapper>
                </div>
                <div class="row">
                    <widgetInputWrapper title="End Date & Time">
                        <datetime class="input-date" v-model="eventForm.end" type="datetime" format="yyyy-MM-dd HH:mm"
                            :min-datetime="moment(eventForm.start).add(1, 'days').toISOString()" style="width: 100%">
                            <span class="date-icon" slot="after"
                                style="padding: 0px; margin-top: 3px; padding-right: 10px">
                                <img src="@/assets/admin-icon/calendar.svg" />
                            </span>
                        </datetime>
                    </widgetInputWrapper>
                </div>
                <div class="row" v-if="false">
                    <widgetInputWrapper title="Event Type">
                        <widgetSelect v-model="eventForm.type" :opt="[
                            { label: 'Task', value: 'task' },
                            { label: 'Meeting', value: 'meeting' },
                            { label: 'Reminder', value: 'reminder' }
                        ]" placeholder="Select event type"></widgetSelect>
                    </widgetInputWrapper>
                </div>
            </div>
        </widgetModal>
    </div>
</template>

<script>
import { eventBus } from "@/main";

export default {
    name: "add-event-modal",
    props: {
        event: {
            type: Object,
            default: () => null,
        },
        type: {
            type: String,
            default: "google",
        },
    },
    data() {
        return {
            eventForm: {
                title: "",
                start: "",
                end: "",
                canGenerateGoogleMeetLink: false,
                type: "reminder",
            },
            loading: false,
        };
    },
    mounted() {
        let vm = this;
        if (this.event) {
            this.populateForm();
        } else {
            vm.eventForm.start = vm.moment().toISOString();
            vm.eventForm.end = vm.moment().add(1, "days").toISOString();
        }
    },
    methods: {
        generateGoogleMeetLink() {

        },
        // Populate form with existing event data if editing
        populateForm() {
            this.eventForm = { ...this.event };
        },

        // Handle form submission
        onConfirm() {
            this.loading = true;
            this.eventForm.type = this.type;
            const action = this.event ? "CALENDAR_UPDATE_EVENT" : "CALENDAR_ADD_EVENT";

            this.$store.dispatch(action, this.eventForm)
                .then(() => {
                    this.$emit("success");
                    this.$notify({
                        group: "status",
                        title: "Success",
                        text: `Event ${this.event ? 'updated' : 'added'} successfully`,
                        type: "success",
                    });
                })
                .catch((error) => {
                    console.error("Error saving event:", error);
                    this.$notify({
                        group: "status",
                        title: "Error",
                        text: "Failed to save event",
                        type: "warn",
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        // Handle modal cancellation
        onCancel() {
            this.$emit("close");
        },
    },
};
</script>

<style lang="scss" scoped>
.page-modal {
    // Add any specific styles here
}
</style>
